import { useEffect, useState } from "react";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import API from "../../../../api";
import { LineChart } from "@mui/x-charts";
import { boxStyle, logColor } from "../../../../theme";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const LogsChart = ({dateFilter, ip, onDataStateChange}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const timezone = sessionStorage.getItem("timezone") || 'Etc/GMT';

  const series = [
    {
      dataKey: "critical",
      label: "Critical",
      color: logColor[1],
      showMark: false,
    },
    {
      dataKey: "high",
      label: "High",
      color: logColor[0],
      showMark: false,
    },
    {
      dataKey: "alert",
      label: "Alert",
      color: logColor[2],
      showMark: false,
    },
    {
      dataKey: "movements",
      label: "Movements",
      color: logColor[3],
      showMark: false,
    },
    {
      dataKey: "threat",
      label: "Threat",
      color: logColor[4],
      showMark: false,
    }
  ]

  useEffect(() => {
    if (!ip) {
      onDataStateChange?.(false);
      return;
    }

    setLoading(true);
    const format = getTimeFormat(dateFilter);
    API.getLogsIp({dateFilter, ip: ip, format: format, timezone: timezone}).then((result) => {
      const rows = result.data || [];
      setData(rows);
      onDataStateChange?.(rows.length > 0);
    }).catch((err) => {
      console.error(err);
      onDataStateChange?.(false);
    }).finally(() => {
      setLoading(false);
    });

  }, [ip, dateFilter, onDataStateChange, timezone]);

  if (!loading && data.length === 0) return null;

  return (
    <Box sx={{
      ...boxStyle,
      display: "flex",
      flexDirection: "column",
      height: 420
    }}>
      <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888", mb: 2 }}>
        Event timeline (5 types) — {getTimeFormat(dateFilter) === 'hour' ? 'hourly' : 'daily'} view
      </Typography>
      {loading ?
        <Box sx={{ mt: 1 }}>
          <Stack direction="row" spacing={0.75} alignItems="flex-end" sx={{ height: 310, px: 1, pt: 2 }}>
            {[60, 85, 45, 100, 70, 55, 80].map((h, i) => (
              <Skeleton
                key={i}
                variant="rounded"
                sx={{
                  flex: 1,
                  height: `${h}%`,
                  bgcolor: "rgba(255,255,255,0.07)",
                  borderRadius: "4px 4px 0 0",
                }}
              />
            ))}
          </Stack>
          <Stack direction="row" spacing={0.75} sx={{ px: 1, mt: 0.5 }}>
            {[...Array(7)].map((_, i) => (
              <Skeleton key={i} variant="text" sx={{ flex: 1, bgcolor: "rgba(255,255,255,0.05)" }} />
            ))}
          </Stack>
        </Box>
      :
        <LineChart
          loading={loading}
          //height={"100%"}
          series={series}
          dataset={data}
          xAxis={[{
            dataKey: "date",
            valueFormatter: (value) => dayjs(value).format(getTimeFormat(dateFilter) === "hour" ? "HH:mm" : "YYYY-MM-DD"),
            scaleType: 'point',
          }]}
          grid={{ horizontal: true, vertical: false }}
          sx={{
            '& .MuiLineElement-root': {
              strokeWidth: 2,
            },
            '& .MuiAreaElement-root': {
              fillOpacity: 0.1,
            }
          }}
        />
      }
    </Box>
  )
}

export default LogsChart;

const getTimeFormat = (dateFilter) => {
  const diff = dayjs.duration(dateFilter?.dateTo?.diff(dateFilter?.dateFrom)).asHours();
  if(diff <= 48){
    return 'hour';
  }else{
    return 'day';
  }
}
